import React from 'react';

const Hero = () => {
  return (
    <section className="hero">
      <div className="particles">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>
      
      <img 
        src="https://i.postimg.cc/zBHCsf4R/controller.png" 
        alt="Gamepad" 
        className="floating-img gamepad-img"
      />
      <img 
        src="https://i.postimg.cc/fTR4YndC/Gemini-Generated-Image-ecvjxgecvjxgecvj.png" 
        alt="Raix Bot" 
        className="floating-img bot-img"
      />
      
      <div className="hero-content">
        <h1>Raix</h1>
        <p className="tagline">
          Transform your Discord server with RAIX - the most powerful all-in-one bot featuring advanced moderation, engaging entertainment, comprehensive utility tools, and seamless automation. Elevate your community experience with intelligent features designed to make server management effortless and fun.
        </p>
        <div className="hero-buttons">
          <a 
            href="https://discord.com/oauth2/authorize?client_id=1430529243254751353" 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Add to Discord
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
